import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface SetShowMetricsBannerParams {
  showMetricsBanner: boolean;
}

export class SetShowMetricsBannerRequest extends Request<SetShowMetricsBannerParams, IResult> {
  constructor(params: SetShowMetricsBannerParams) {
    super('setShowMetricsBanner', params);
  }
}
